import { AxiosInstance } from "axios"

export type SpireTestApiRecord = {
	recordDate: string
	recordId: string
	fhirBundle: any
}

export class SpireEchoClient {
	constructor(private axiosInstance: AxiosInstance) {}

	private base = "/manage/spire/integration"

	private jsonParseOrRaw = (input: string) => {
		try {
			return JSON.parse(input)
		} catch (e) {
			console.warn("Unable to parse input", { input, e })
			return input
		}
	}

	public add = (newRecords: string) => {
		const model = { records: this.jsonParseOrRaw(newRecords) }
		return this.axiosInstance.put<void>(`${this.base}/add`, model)
	}
	public clear = () => this.axiosInstance.delete<void>(`${this.base}/clear`)
	public records = () =>
		this.axiosInstance.get<SpireTestApiRecord[]>(`${this.base}/records`)
}
